"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveCodecError = void 0;
const misc_1 = require("@moojo/misc");
const zod_1 = require("zod");
const sdk_error_1 = require("../sdk-error");
const resolveCodecError = (e) => {
    if (e instanceof sdk_error_1.SdkError) {
        return e;
    }
    let message = undefined;
    if (e instanceof SyntaxError) {
        message = 'Bad JSON format';
    }
    else if (e instanceof zod_1.ZodError) {
        const customError = e.errors.find(err => err.code === 'custom');
        message = customError ? customError.message : 'Schema parsing error';
    }
    else {
        message = (0, misc_1.errorLike)(e, 'unknown error').message;
    }
    return new sdk_error_1.SdkError('data_encoding_error', { message, cause: e });
};
exports.resolveCodecError = resolveCodecError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzb2x2ZS1jb2RlYy1lcnJvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb2RlYy9yZXNvbHZlLWNvZGVjLWVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHNDQUF1QztBQUN2Qyw2QkFBOEI7QUFFOUIsNENBQXVDO0FBRWhDLE1BQU0saUJBQWlCLEdBQUcsQ0FBQyxDQUFVLEVBQUUsRUFBRTtJQUM5QyxJQUFJLENBQUMsWUFBWSxvQkFBUSxFQUFFLENBQUM7UUFDMUIsT0FBTyxDQUFDLENBQUE7SUFDVixDQUFDO0lBRUQsSUFBSSxPQUFPLEdBQXVCLFNBQVMsQ0FBQTtJQUMzQyxJQUFJLENBQUMsWUFBWSxXQUFXLEVBQUUsQ0FBQztRQUM3QixPQUFPLEdBQUcsaUJBQWlCLENBQUE7SUFDN0IsQ0FBQztTQUFNLElBQUksQ0FBQyxZQUFZLGNBQVEsRUFBRSxDQUFDO1FBQ2pDLE1BQU0sV0FBVyxHQUFHLENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxDQUFDLElBQUksS0FBSyxRQUFRLENBQUMsQ0FBQTtRQUMvRCxPQUFPLEdBQUcsV0FBVyxDQUFDLENBQUMsQ0FBQyxXQUFXLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxzQkFBc0IsQ0FBQTtJQUN0RSxDQUFDO1NBQU0sQ0FBQztRQUNOLE9BQU8sR0FBRyxJQUFBLGdCQUFTLEVBQUMsQ0FBQyxFQUFFLGVBQWUsQ0FBQyxDQUFDLE9BQU8sQ0FBQTtJQUNqRCxDQUFDO0lBRUQsT0FBTyxJQUFJLG9CQUFRLENBQUMscUJBQXFCLEVBQUUsRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUE7QUFDbkUsQ0FBQyxDQUFBO0FBaEJZLFFBQUEsaUJBQWlCLHFCQWdCN0IifQ==